module.exports = __webpack_public_path__ + "img/lighthouse.670cd0ab.png";